/* eslint-disable no-sequences */
/* eslint-disable indent */
/* eslint-disable prettier/prettier */

// import { initializeApp } from 'firebase/app'
// import { getAnalytics, logEvent } from 'firebase/analytics'
import { eventPost, kwaiqPost, intGoogleSDK, initAF } from './eventFunction'
import { googleAuth } from './googleAuth'
import store from '@/lobby_common/store'
import { utils } from "@/lobby_common/utils/utils";
import { adjustTrackEvent, afPostEvent, gtagGoogle } from "@/lobby_common/utils/eventFunction"
import Bus from '@/lobby_common/utils/bus.js'
import { getLocalStorage, setLocalStorage, removeLocalStorage } from '@/lobby_common/utils/auth'
import { payGameFun } from "@/lobby_common/utils/payGameFun.js";
import { getTronWeb } from '@/lobby_common/utils/adjust.js'
import { intAdjustSDK } from "@/lobby_common/utils/adjust.js";
import { joinNewUserHelp, previewDownloadActivityReward } from "@/lobby_common/api/activity_gen.js";
import { firebaseSave, withdrawGuideShowText } from "@/lobby_common/api/user_gen.js";
import { getUrlkey, encryptPassword } from "@/lobby_common/utils/utils.js";

let vm = null;
export function sendBusThis(_this) {
  vm = _this;
}

// 注册-登陆成功
export async function loginSuccess(params = {}) {
  let { type, event, data } = params
  console.log('loginSuccess', params)

  // 批量创建真实账号-补一个注册事件
  if (type === 'login' && data?.userCreateType === "USER_CREATE_TYPE_PRE_REALITY") {
    type = 'register'
  }

  // 缓存没有用户类型 & 缓存用户类型
  const localUserCreateType = getLocalStorage('localUserType') || null;
  if (!localUserCreateType && data?.userCreateType) {
    setLocalStorage('localUserType', data.userCreateType);
  }

  const eventOpt = { ...data, userSid: data.userSid }
  delete eventOpt.accessToken
  switch (event) {
    case 'ACCOUNT_REGISTER':
    case 'ACCOUNT_LOGIN':
      eventOpt.account = data.account.username
      break
    case 'EMAIL_REGISTER':
    case 'EMAIL_LOGIN':
      eventOpt.email = data.email.email
      break
    case 'MOBILE_REGISTER':
    case 'MOBILE_LOGIN':
      eventOpt.mobile = data.phone.mobile
      delete eventOpt.phone
      break
    default:
  }

  // 注册登陆成功事件上报
  switch (type) {
    case 'register':
      eventPost('register_success', { ...eventOpt, type: event });
      eventPost('login_click_success', { ...eventOpt, type: event });
      // 快手-注册成功
      adjustTrackEvent({ eventToken: 'register' })
      afPostEvent({ event: 'register' })
      gtagGoogle('sign_up')
      kwaiqPost('completeRegistration')
      break
    case 'login':
      eventPost('login_click_success', { ...eventOpt, type: event });
      // 判断用户语言以及当前语言 语言不相同时会刷新页面，不调用adjust登录上报
      const urlObj = getUrlkey()
      const languageArr = store.getters.getPacketConfig?.packetInfo?.baseInfo?.languages || ['en']
      if (data.language && languageArr?.includes(data.language) && data.language !== store.getters.getLang && !urlObj.language) {
        return false
      } else {
        adjustTrackEvent({ eventToken: 'login' })
        afPostEvent({ event: 'login' })
      }
      break
    default:
  }

  console.log('key999', data)
  let saveData = {}
  // 缓存账号密码
  let key = '';
  let password = '';
  if (event === 'ACCOUNT_REGISTER' || event === 'ACCOUNT_LOGIN' || event === 'VISITOR_LOGIN') {
    key = 'account'
    password = encryptPassword(data?.account?.password || '')
    saveData = { username: data.account.username, password, }
  }
  if (event === 'MOBILE_REGISTER' || event === 'MOBILE_LOGIN') {
    key = 'phone';
    password = encryptPassword(data?.phone?.password || '')
    saveData = { mobile: data.phone.mobile, mobilePrefix: data.phone.mobilePrefix, password }
  }
  if (event === 'EMAIL_REGISTER' || event === 'EMAIL_LOGIN') {
    key = 'email'
    password = encryptPassword(data?.email?.password || '')
    saveData = { email: data.email.email, password }
  }
  if (key) {
    console.log('key999', key, saveData)
    const pwdData = getLocalStorage('PASSWORD_MAP') || {}
    setLocalStorage('PASSWORD_MAP', {
      ...pwdData,
      [key]: {
        ...saveData,
      },
      last: key,
    })
  }
  // 登陆标识
  localStorage.setItem("quickLoginFlag", 1);
  localStorage.setItem("isNewDevice", "false");

  store.dispatch("getEnableFeatureApi");

  // 保存用户Firebase信息(从马甲包里面传过来的设备token)
  const fcmRegisterToken = getLocalStorage('fcmRegisterToken');
  if (fcmRegisterToken) {
    const { code } = await firebaseSave({ token: fcmRegisterToken });
    if (code === 0) {
      removeLocalStorage('fcmRegisterToken');
    }
  }

  //  拉新助力活动
  const joinKey = getLocalStorage('joinKey');
  if (joinKey) {
    const { code } = await joinNewUserHelp({ joinKey });
    if (code === 0) {
      removeLocalStorage('joinKey');
    }
  }

  // 如果是创房邀请的  直接进游戏
  let createRoomModal = localStorage.getItem("creatRoomParams");
  createRoomModal = JSON.parse(createRoomModal) || {};
  if (createRoomModal.game_id && createRoomModal.share_type) {
    localStorage.removeItem("creatRoomParams");
    const currentTime = Math.floor(Date.now() / 1000);
    if (currentTime > createRoomModal.time + 300) {
      return;
    }
    const params = {
      gameGroupSid: createRoomModal.game_id,
      ...createRoomModal,
    };
     store.commit("setRecordGame", params);
    payGameFun(params, createRoomModal.type);
    return;
  }

  // 获取下载奖励
  const rawardTimer = setTimeout(async () => {
    const downloadRewardClaimStatus = vm.$store.getters.getDownloadRewardClaimStatus
    console.log(downloadRewardClaimStatus, 'downloadRewardClaimStatus2')
    if (!downloadRewardClaimStatus) { // 未领取
      const rawardRes = await previewDownloadActivityReward({}); // 下载奖励
      const rewardType = rawardRes?.data?.rewardType;
      if (!rewardType || rewardType === "ACTIVITY_REWARD_TYPE_UNKNOWN") {
        return false;
      }
      if (rewardType === "ACTIVITY_REWARD_TYPE_MONEY") {
        const amount = rawardRes?.data?.amount
          ? rawardRes?.data?.amount
          : 0;
        if (Number(amount) > 0) {
          Bus.$emit("rewardShow", {
            amount: amount,
            coinCode: rawardRes?.data?.coinCode,
          });
          vm.$store.commit("setDownloadRewardClaimStatus", true)
        }
      } else {
        Bus.$emit("rewardTipsShow", rawardRes?.data);
      }
      clearTimeout(rawardTimer);
    }
  }, 5000)

  withdrawGuideShowText().then(res => {
    if (res.code === 0) {
      const enableExchangeTips = res.data.show === 'ROW_STATUS_ENABLE';
      vm.$store.commit("setEnableExchangeTips", enableExchangeTips);
    }
  })
}

// 动态创建标签，icon  描述
export function eventsInit(configData) {
  // console.log('eventsInit', configData)
  const isFromApp = Boolean(window.localStorage.getItem('isFromApp'))

  let params = window.localStorage.getItem('localInitQuery')
  if (params) {
    params = JSON.parse(params)
  }
  // const computedStyle = getComputedStyle(document.documentElement);
  //   const themeColor = computedStyle.getPropertyValue('--background-100').trim();
    //  const metaTag = document.querySelector('meta[name="theme-color"]');

  // if (metaTag && themeColor) {
      // metaTag.setAttribute('content', '#f6040f');
  // }
  //  const metaTag = document.querySelector('meta[name="theme-color"]');
  //   metaTag.setAttribute('content', '#13161e');
  // 网站相关配置
  if (configData?.site?.siteTitle) {
    document.title = configData?.site?.siteTitle
    window.BASEAPI.title = configData?.site?.siteTitle
  }
  if (configData?.site?.siteIcon) {
    const meta = document.createElement('meta')
    const link1 = document.createElement('link')
    const link2 = document.createElement('link')
    link1.rel = 'icon'
    link1.href = utils.returnImgUrl(configData?.site?.siteIcon)
    link2.rel = 'apple-touch-icon-precomposed'
    link2.href = utils.returnImgUrl(configData?.site?.siteIcon)
    meta.property = 'og:image'
    meta.content = utils.returnImgUrl(configData?.site?.siteIcon)
    document.getElementsByTagName('head')[0].appendChild(meta)
    document.getElementsByTagName('head')[0].appendChild(link1)
    document.getElementsByTagName('head')[0].appendChild(link2)
  }
  if (configData?.site?.description) {
    const meta = document.createElement('meta')
    meta.name = 'og:description'
    meta.content = configData?.site?.description
    document.getElementsByTagName('head')[0].appendChild(meta)
  }
  if (configData?.site?.keywords) {
    const meta = document.createElement('meta')
    meta.name = 'keywords'
    meta.content = configData?.site?.keywords
    document.getElementsByTagName('head')[0].appendChild(meta)
  }

  // // google 登陆
  // if (configData?.loginConfig?.googleSwitch === 1) {
  //   const obj = configData?.packet_config || {}
  //   const CLIENT_ID = obj.google_appid
  //   const API_KEY = obj.google_secret

  //   console.log('google 登陆', CLIENT_ID, API_KEY)
  //   if (!(!CLIENT_ID || !API_KEY)) {
  //     googleAuth(CLIENT_ID, API_KEY)
  //     ;(function (d, s, w) {
  //       var gjs
  //       let script = d.getElementsByTagName(s)[0]
  //       gjs = d.createElement(s)
  //       gjs.async = true
  //       gjs.defer = true
  //       gjs.src = 'https://accounts.google.com/gsi/client'

  //       gjs.onload = w.gisLoaded

  //       script.parentNode.insertBefore(gjs, script)
  //     })(document, 'script', window)
  //   }
  // }

  // // tron 登陆
  // if (configData?.loginConfig?.tronSwitch === 1) {
  //   //
  //   getTronWeb()
  // }
}

// 三方上报初始化
export async function adsEventsInit(adsEventConfig) {
  // 存在三方上报配置
  if (adsEventConfig && adsEventConfig.length) {
    const channelCodeObj = {}
    adsEventConfig.map(v => {
      channelCodeObj[v.channelCode] = { ...v }
    })

    // google
    if (channelCodeObj['ADS_CODE_GOOGLEPUSH']) {
      const configJson = channelCodeObj['ADS_CODE_GOOGLEPUSH']?.config || ''
      const config = configJson ? JSON.parse(configJson) : {}
      // 初始化google
      intGoogleSDK(config)
      // intGoogleSDK({ id: "G-0F6X2DHSXK" })
    }
    // adjust
    if (channelCodeObj['ADS_CODE_ADJUST']) {
      const configJson = channelCodeObj['ADS_CODE_ADJUST']?.config || ''
      const config = configJson ? JSON.parse(configJson) : {}
      // 初始化adjust
      intAdjustSDK(config)
    }

    if (channelCodeObj['ADS_CODE_AF']) {
      // const configJson = channelCodeObj['ADS_CODE_AF']?.config || ''
      // const config = configJson ? JSON.parse(configJson) : {}
      const funConfigJson = channelCodeObj['ADS_CODE_AF']?.funcConfig || ''
      const funcConfig = funConfigJson ? JSON.parse(funConfigJson) : {}
      // 初始化adjust
      initAF(funcConfig, adsEventConfig)
    }

    // kwai_pixel 快手上报
    if (channelCodeObj['ADS_CODE_KWAI']) {
      const configJson = channelCodeObj['ADS_CODE_KWAI']?.config || ''
      const config = configJson ? JSON.parse(configJson) : {}
      window.kwai_pixel = config.pixel
      !(function(e, t) { typeof exports === "object" && typeof module === "object" ? module.exports = t() : typeof define === "function" && define.amd ? define([], t) : typeof exports === "object" ? exports.install = t() : e.install = t() }(window, function() { return (function(e) { var t = {}; function n(o) { if (t[o]) return t[o].exports; var r = t[o] = { i: o, l: !1, exports: {}}; return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports } return n.m = e, n.c = t, n.d = function(e, t, o) { n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: o }) }, n.r = function(e) { typeof Symbol !== "undefined" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 }) }, n.t = function(e, t) { if (1 & t && (e = n(e)), 8 & t) return e; if (4 & t && typeof e === "object" && e && e.__esModule) return e; var o = Object.create(null); if (n.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: e }), 2 & t && typeof e !== "string") for (var r in e)n.d(o, r, function(t) { return e[t] }.bind(null, r)); return o }, n.n = function(e) { var t = e && e.__esModule ? function() { return e.default } : function() { return e }; return n.d(t, "a", t), t }, n.o = function(e, t) { return Object.prototype.hasOwnProperty.call(e, t) }, n.p = "", n(n.s = 0) }([function(e, t, n) { "use strict"; var o = this && this.__spreadArray || function(e, t, n) { if (n || arguments.length === 2) for (var o, r = 0, i = t.length; r < i; r++)!o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]); return e.concat(o || Array.prototype.slice.call(t)) }; Object.defineProperty(t, "__esModule", { value: !0 }); var r = function(e, t, n) { var o; var i = e.createElement("script"); i.type = "text/javascript", i.async = !0, i.src = t, n && (i.onerror = function() { r(e, n) }); var a = e.getElementsByTagName("script")[0]; (o = a.parentNode) === null || void 0 === o || o.insertBefore(i, a) }; !(function(e, t, n) { e.KwaiAnalyticsObject = n; var i = e[n] = e[n] || []; i.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"]; var a = function(e, t) { e[t] = function() { for (var n = [], r = 0; r < arguments.length; r++)n[r] = arguments[r]; var i = o([t], n, !0); e.push(i) } }; i.methods.forEach(function(e) { a(i, e) }), i.instance = function(e) { var t; var n = ((t = i._i) === null || void 0 === t ? void 0 : t[e]) || []; return i.methods.forEach(function(e) { a(n, e) }), n }, i.load = function(e, o) { var a = "https://s1.kwai.net/kos/s101/nlav11187/pixel/events.js"; i._i = i._i || {}, i._i[e] = [], i._i[e]._u = a, i._t = i._t || {}, i._t[e] = +new Date, i._o = i._o || {}, i._o[e] = o || {}; var c = "?sdkid=".concat(e, "&lib=").concat(n); r(t, a + c, "https://s16-11187.ap4r.com/kos/s101/nlav11187/pixel/events.js" + c) } }(window, document, "kwaiq")) }])) }));
      window.kwaiq.load(window.kwai_pixel);
      window.kwaiq.page();
      if (vm.$route.path === '/home' || vm.$route.path === '/') {
        // 快手-首页被访问
        kwaiqPost('contentView')
      }

      // 初始化没有参数需要拼接上
      const kwai_obj = getLocalStorage("kwai_obj");
      const params = new URLSearchParams(window.location.search);
      if (kwai_obj?.click_id && kwai_obj?.pixel_id && !params.pixel_id && !params.click_id) {
        params.set('pixel_id', kwai_obj?.pixel_id);
        params.set('click_id', kwai_obj?.click_id);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        console.log('router9999999888888', newUrl)
        vm.$router.replace({
          path: newUrl,
        }).catch(error => {
          if (error.name !== "NavigationDuplicated") {
            throw error;
          }
        });
      }
    }
  }
}
